import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { memoWithAs, forwardRefWithAs } from '@stacks/ui-core';
import { Box } from './box/index.esm.js';
import { transition } from '@stacks/ui-theme';
import { color } from '@stacks/ui-utils';
import { Grid } from './grid/index.esm.js';
import './color-modes/index.esm.js';
import { useHover } from 'use-events';

var IconButton = /*#__PURE__*/memoWithAs( /*#__PURE__*/forwardRefWithAs(function (props, ref) {
  var _useHover = useHover(),
      _isHovered = _useHover[0],
      bind = _useHover[1];

  var Icon = props.icon,
      _props$iconSize = props.iconSize,
      iconSize = _props$iconSize === void 0 ? "20px" : _props$iconSize,
      _props$iconProps = props.iconProps,
      iconProps = _props$iconProps === void 0 ? {} : _props$iconProps,
      invert = props.invert,
      _props$_hover = props._hover,
      _hover = _props$_hover === void 0 ? {} : _props$_hover,
      isHovered = props.isHovered,
      rest = _objectWithoutPropertiesLoose(props, ["icon", "iconSize", "iconProps", "invert", "_hover", "isHovered"]);

  var hovered = _isHovered || isHovered;
  return /* @__PURE__ */React__default.createElement(Grid, _extends({
    placeItems: "center",
    borderRadius: "100%",
    transition: transition,
    size: "36px",
    position: "relative",
    userSelect: "none",
    _hover: _extends({
      cursor: "pointer"
    }, _hover),
    color: "currentColor",
    ref: ref
  }, bind, rest), /* @__PURE__ */React__default.createElement(Icon, _extends({
    display: "block",
    size: iconSize,
    color: "currentColor"
  }, iconProps)), /* @__PURE__ */React__default.createElement(Box, {
    position: "absolute",
    left: 0,
    top: 0,
    borderRadius: "100%",
    size: "100%",
    bg: color(invert ? "bg" : "invert"),
    transition: transition,
    opacity: hovered ? 0.12 : 0
  }));
}));

export { IconButton };
//# sourceMappingURL=icon-button.esm.js.map
